{
  "dss": {
    "button": {
      "back": "뒤로",
      "cancel": "취소",
      "close": "닫기",
      "confirmDelete": "예, 삭제",
      "continue": "계속",
      "logout": "로그아웃",
      "passwordReset": "비밀번호 재설정",
      "save": "저장",
      "verify": "확인"
    },
    "error": {
      "403": "이 페이지에 접근 권한이 없습니다.",
      "404": "이 페이지는 존재하지 않습니다.",
      "generic": "오류가 발생했습니다. 나중에 다시 시도해 주세요.",
      "throttling": "시도가 너무 많습니다. 잠시 후 다시 시도해 주세요.",
      "title": "오류",
      "title403": "접근 거부",
      "title404": "찾을 수 없음"
    },
    "footer": {
      "imprint": "회사 정보",
      "legalEntity": "ANDREAS STIHL AG & Co. KG, D-71336 Waiblingen",
      "privacy": "개인정보 처리방침",
      "terms": "이용약관"
    },
    "label": {
      "CRMAccountNumber": "CRM 계정 번호",
      "contact": "연락처",
      "email": "이메일",
      "faq": "FAQ",
      "female": "여",
      "firstname": "이름",
      "help": "도움말",
      "language": "언어",
      "lastname": "성",
      "male": "남",
      "needHelp": "도움이 필요하신가요?",
      "newPassword": "새 비밀번호",
      "newPassword2": "새 비밀번호 확인",
      "oldPassword": "현재 비밀번호",
      "organization": "조직",
      "password": "비밀번호",
      "required": "필수",
      "salutation": "호칭",
      "select": "선택하세요"
    },
    "lang": {
      "de": "독일어"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "등록 확인",
        "wait": "계정 확인이 완료될 때까지 잠시 기다려 주세요."
      },
      "otp": {
        "btnResend": "인증 코드 이메일 다시 보내기",
        "msg": {
          "invalidOTP": "입력한 일회용 비밀번호가 유효하지 않습니다.",
          "resendFail": "코드 재전송에 실패했습니다. 나중에 다시 시도해 주세요."
        },
        "spamDetail": "받은편지함 및 스팸 폴더에서 STIHL Support (noreply{'@'}stihl-sso.com)의 이메일을 확인해 주세요",
        "spamTitle": "이메일을 받지 못하셨나요?",
        "subtitle": "계속하려면 이메일 주소를 확인해야 합니다.",
        "title": "사용자 계정 확인",
        "txtVerifyMail": "이메일 주소 {email}로 보낸 새 인증 코드를 입력해 주세요"
      },
      "personal": {
        "msg": {
          "noChange": "업데이트할 내용이 없습니다.",
          "updateError": "개인 정보 업데이트에 실패했습니다.",
          "updated": "개인 정보가 업데이트되었습니다.",
          "userLoadErr": "사용자 데이터를 불러오는 중 오류가 발생했습니다. 나중에 다시 시도해 주세요."
        },
        "secOrganization": "조직",
        "secPersonal": "개인",
        "secSettings": "기본 설정",
        "title": "개인 정보"
      },
      "postPwSet": {
        "info": "이제 새 비밀번호를 사용할 수 있습니다.",
        "link_name": "셀프 서비스로 계속",
        "link_url": "/user/ui/",
        "title": "비밀번호가 변경되었습니다"
      },
      "resetPW": {
        "title": "비밀번호 재설정"
      },
      "security": {
        "2fa": {
          "availableMethods": "사용 가능한 2FA 방법:",
          "info": "2단계 인증(2FA)은 계정에 추가 보호 계층을 추가하는 보안 기능입니다. 사용자 이름과 비밀번호만 사용하는 대신 로그인에 두 가지 방법을 사용해야 합니다.",
          "method": {
            "email": "이메일",
            "emailDesc": "인증 요청을 완료하기 위해 이메일로 일회용 코드를 받습니다.",
            "oath": {
              "add": {
                "button": "인증 앱 등록"
              }
            }
          }
        },
        "authenticator": "인증 앱",
        "infoFederatedAccount": "이 계정은 조직의 ID 공급자가 관리하므로 여기서 비밀번호를 변경할 수 없습니다. 비밀번호를 변경하려면 조직의 로그인 페이지를 통해 로그인하거나 IT 관리자에게 문의하세요.",
        "lastUse": "마지막 사용 시간: {0}.",
        "msg": {
          "invalidPassword": "현재 비밀번호가 유효하지 않습니다.",
          "passwordAlreadyUsed": "최근 5개의 비밀번호는 재사용할 수 없습니다.",
          "pwUpdateError": "비밀번호 변경 중 오류가 발생했습니다.",
          "pwUpdated": "비밀번호가 변경되었습니다."
        },
        "noDevice": "구성되지 않음",
        "oathAdd": {
          "appInfo": "STIHL 로그인 과정을 더 쉽게 하기 위해 {0}, {1}, {2} 등의 인증 앱을 사용하여 로그인 과정에서 두 번째 요소로 사용되는 일회용 비밀번호를 생성할 수 있습니다.<br/>모바일 기기를 분실하거나 잊어버린 경우에도 이메일로 전송된 2FA 코드를 언제든지 사용할 수 있습니다.<br/><br/>아래 안내를 따라 인증 장치를 설정하세요.",
          "badCode": "유효하지 않은 코드입니다. 다시 시도해 주세요.",
          "error": "인증 장치를 등록하는 중 오류가 발생했습니다.",
          "headScan": "1. 인증 앱으로 QR 코드를 스캔하세요",
          "headVerify": "2. 코드를 확인하세요",
          "infoKey": "설정 키",
          "infoKeyTitle": "2단계 인증 비밀 키",
          "infoScanBottom": "스캔할 수 없나요? {0}을 사용해 인증 앱을 수동으로 설정할 수 있습니다.",
          "infoVerify": "인증 앱에서 생성한 코드를 입력하세요.",
          "success": "인증 장치가 등록되었습니다. 이제 로그인에 사용할 수 있습니다.",
          "title": "2단계 인증 장치 등록"
        },
        "oathDelete": {
          "error": "인증 장치를 삭제하는 중 오류가 발생했습니다.",
          "success": "인증 장치가 삭제되었습니다."
        },
        "passkeys": {
          "about": {
            "info1": "패스키는 사용자가 제어하는 인증 장치에 저장되는 암호화 키 쌍(공개 키와 개인 키)입니다. 인증 장치는 사용자가 실제로 존재하며 패스키를 사용할 권한이 있음을 증명할 수 있습니다. 인증 장치는 기능과 설정에 따라 PIN, 코드, 생체 인증 또는 기기 비밀번호로 권한을 증명합니다. 인증 장치는 iPhone 또는 Android 기기, Windows Hello, FIDO2 하드웨어 보안 키, 비밀번호 관리자 등 다양한 형태가 있습니다.",
            "info2": "패스키를 사용해 STIHL에 로그인하면, 인증 장치는 패스키를 전송하지 않고 공개 키 암호화를 사용해 STIHL에 본인의 신원을 증명합니다. 패스키는 stihl-sso.com과 같은 웹사이트 도메인에 바인딩되며 보안 연결이 필요하므로, 웹 브라우저는 피싱 사이트와 같은 위장 사이트에 대한 인증을 거부합니다. 이러한 특성으로 패스키는 피싱에 매우 강하며, 피싱이 가능한 SMS 또는 TOTP 2FA보다 공격이 훨씬 어렵습니다.",
            "info3": "클라우드 동기화가 지원되는 패스키 서비스는 패스키를 여러 기기(예: Apple 기기, Android 기기 또는 비밀번호 관리자) 간에 동기화할 수 있어 더 다양한 곳에서 사용할 수 있고 분실 위험이 줄어듭니다. 한 기기에 동기화된 패스키를 설정하면 동일한 서비스를 사용하는 여러 기기에서 해당 패스키를 사용할 수 있습니다. 예를 들어, MacBook의 Touch ID를 사용하여 iCloud 계정에 패스키를 등록하면, 이후 해당 iCloud 계정과 연결된 여러 기기에서 얼굴, 지문, PIN 또는 기기 비밀번호로 해당 패스키를 교차 사용 할 수 있습니다.",
            "title": "패스키 소개"
          },
          "add": {
            "button": "새 Passkey 추가",
            "error": "새 패스키를 추가하는 중 오류가 발생했습니다.",
            "success": "새 패스키가 추가되었습니다."
          },
          "delete": {
            "button": "Passkey 삭제",
            "error": "이 패스키를 삭제하는 중 오류가 발생했습니다.",
            "success": "패스키가 삭제되었습니다."
          },
          "edit": {
            "error": "패스키 이름을 저장하는 중 오류가 발생했습니다.",
            "name": "Passkey 이름",
            "success": "Passkey 이름이 업데이트되었습니다.",
            "title": "다른 패스키와 구분할 수 있도록 Passkey에 이름을 지정하세요"
          },
          "info": "패스키는 터치, 얼굴 인식, 기기 비밀번호 또는 PIN을 사용하여 본인 인증을 수행하는 비밀번호의 간단하고 안전한 대안입니다.",
          "none": "구성된 Passkey가 없습니다.",
          "reallyDelete": "정말로 Passkey를 삭제하시겠습니까?",
          "registeredPasskeys": "등록된 Passkey:",
          "title": "Passkeys"
        },
        "reallyDeleteDevice": "정말로 인증 장치를 삭제하시겠습니까?",
        "secMFA": "2단계 인증",
        "secPwdChange": "비밀번호 변경",
        "title": "보안"
      },
      "setPW": {
        "acceptTC": "저희의 {terms}에 동의하고 {privacy}를 읽어 주세요.",
        "killSSO": "모든 활성 세션 무효화",
        "msg": {
          "tokenExpired": "비밀번호 링크 또는 코드가 만료되었습니다. 비밀번호를 재설정하려면 링크를 따라가 주세요: {link}."
        },
        "privacy": "데이터 개인정보 보호정책",
        "terms": "이용 약관",
        "title": "새 비밀번호 입력"
      }
    },
    "validations": {
      "hasDigit": "숫자가 포함되어야 합니다",
      "hasLowercase": "소문자가 포함되어야 합니다",
      "hasSpecial": "특수 문자가 포함되어야 합니다: {chars}",
      "hasUppercase": "대문자가 포함되어야 합니다",
      "invalidCharacters": "유효하지 않은 문자가 포함되어 있습니다",
      "maxLength": "최대 {max}자까지 허용됩니다",
      "minLength": "최소 {min}자 이상이어야 합니다",
      "notSameAsEmail": "이메일 주소와 너무 유사합니다",
      "onlyValidCharactersAllowed": "문자, 숫자 및 공백만 허용됩니다.",
      "required": "필수 값",
      "sameAsPassword": "비밀번호가 일치하지 않습니다",
      "tcAccepted": "이용 약관에 동의해 주세요.",
      "validEmail": "유효하지 않은 이메일 주소입니다.",
      "validOTP": "인증 코드를 입력해 주세요."
    }
  }
}
